import { useRef, useState } from "react";
import RichText from "@/components/RichText";
import { ContractActions } from "@/components/ContractActions";
import { ContractPlaceholderLegend } from "@/components/ContractPlaceholderLegend";

export const ContractEditorPanel = ({ contract, setContract, versions, fields, onSaveDraft,
  onPublish, saving, savedContract, draft, nextVersion }) => {
  const editor = useRef(null);
  const [openVersion, setOpenVersion] = useState(null);
  const dirty = contract !== savedContract;
  const status = dirty ? "Modifiche non salvate" : draft
    ? `Bozza salvata il ${new Date(draft.updated_at).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" })}`
    : versions.length ? `Versione ${versions[0].version} pubblicata` : "Nessuna bozza salvata";
  const controls = (position) => <ContractActions position={position} onSaveDraft={onSaveDraft}
    onPublish={onPublish} saving={saving} status={status}
    hasContent={!!contract.replace(/<[^>]+>/g, "").trim()}
    canPublish={!!contract.replace(/<[^>]+>/g, "").trim() && contract !== versions[0]?.html} />;

  return <section className="border-t border-[#E5E5E0] pt-5 pb-12" data-testid="contract-section">
    <div className="mb-3 flex flex-wrap items-start justify-between gap-x-6 gap-y-3">
      <h2 className="font-serif text-2xl">Contratto</h2>
      <div className="ml-auto flex min-w-0 flex-col items-end gap-1 text-right" data-testid="contract-actions-summary">
        <span className="text-xs text-[#707070]" data-testid="contract-next-version">Prossima versione: {nextVersion}</span>
        {controls("top")}
      </div>
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_260px] gap-8">
      <RichText ref={editor} value={contract} onChange={setContract} minHeight={320} testId="contract-editor" allowTypography viewportHeight />
      <ContractPlaceholderLegend fields={fields} onInsert={(token) => editor.current?.insertText(token)} />
    </div>
    <div className="border-t border-[#E5E5E0] pt-6 mt-8">{controls("bottom")}</div>
    <section className="border-t border-[#E5E5E0] mt-12 pt-8" data-testid="contract-version-history">
      <h2 className="font-serif text-2xl mb-5">Versioni pubblicate</h2>
      {versions.length === 0 && <p className="text-sm text-[#707070]" data-testid="contract-no-versions">Nessuna versione pubblicata.</p>}
      {versions.map((version) => <div key={version.id} className="border-b border-[#E5E5E0] py-4">
        <button type="button" onClick={() => setOpenVersion(openVersion === version.id ? null : version.id)}
          className="w-full text-left flex justify-between items-center hover:text-[#8C3A3A] transition-colors"
          aria-expanded={openVersion === version.id} data-testid={`contract-history-version-${version.version}`}>
          <strong>Versione {version.version}</strong>
          <time className="text-sm text-[#707070]">{new Date(version.published_at).toLocaleString("it-IT")}</time>
        </button>
        {openVersion === version.id && <article className="prose-rt text-sm mt-5 p-5 bg-white border border-[#E5E5E0]"
          dangerouslySetInnerHTML={{ __html: version.html }} data-testid={`contract-history-content-${version.version}`} />}
      </div>)}
    </section>
  </section>;
};